import { RouteInterface } from "src/common";
import { AppRouter, AppRouting } from "src/pages/app";

export const MainRouting = (): Array<RouteInterface> => [
  {
    path: '/',
    element: AppRouter,
    children: AppRouting,
    functions: []
  }
];
